/**
 * The six types the creator OFFERS, out of the taxonomy's seven.
 *
 * `custom` is not a kind of training — it is the absence of one, the value the backend reports for
 * a movement whose type nobody stated. A tile for it would ask the trainer to choose "unspecified"
 * from a row of specifics, so the wizard's radiogroup is the six and the seventh never appears.
 *
 * The order is `EXERCISE_TYPE_KEYS`' own, which is the order the canon draws the 3 × 2 grid in.
 * Derived from the taxonomy rather than restated, so a seventh KIND of training arriving upstream
 * reaches the creator without a second list to remember.
 */

import { EXERCISE_TYPE_KEYS, type ExerciseTypeKey } from '~/entities/exercise-library';

/** Every type a trainer may give an exercise they are authoring. */
export type CreatableExerciseType = Exclude<ExerciseTypeKey, 'custom'>;

function isCreatable(key: ExerciseTypeKey): key is CreatableExerciseType {
  return key !== 'custom';
}

/** The tiles, in the canon's order. */
export const CREATABLE_EXERCISE_TYPES: readonly CreatableExerciseType[] =
  EXERCISE_TYPE_KEYS.filter(isCreatable);

/**
 * The type an EXISTING movement's draft opens on.
 *
 * A movement the backend reports as `custom`, or as a type this build has never heard of, has no
 * tile to light. It opens on `strength` — the first tile, and the one a trainer is most likely to
 * be correcting it to — rather than on an unlit grid whose „wymagane" would refuse a save the
 * trainer cannot see the cause of.
 */
export function creatableTypeOf(key: ExerciseTypeKey | null): CreatableExerciseType {
  return key !== null && isCreatable(key) ? key : 'strength';
}
